import { GridColDef } from '@mui/x-data-grid-premium'

const msrp: GridColDef = {
	field: 'msrp',
	headerName: 'MSRP',
	width: 120,
	sortable: false,
	valueGetter: ( _value, row ) => {
		if ( !row.msrp ) return ''
		return new Intl.NumberFormat( 'en-US', {
			style: 'currency',
			currency: 'USD',
			maximumFractionDigits: 4,
			minimumFractionDigits: 2,
		} ).format( row.msrp )
	},
}

export default msrp
